import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export async function submitLead(payload) {
  const response = await axios.post(`${API_BASE_URL}/api/submissions`, payload);
  return response.data;
}
